import { Flex } from 'antd';

import { ArchiveLabel } from '@app/shared/components';

import type { FC } from 'react';

interface Props {
  title?: string | null;
  isDeleted?: boolean;
  deleteItemDataTestId?: string;
}

export const WidthArchiveLabel: FC<Props> = ({
  title = '',
  isDeleted,
  deleteItemDataTestId = '',
}) => (
  <Flex
    align="center"
    justify="flex-start"
    gap={6}
    data-testid={isDeleted && deleteItemDataTestId}
  >
    {isDeleted && <ArchiveLabel />}
    <span className="no-wrap-text">{title}</span>
  </Flex>
);
